import { Card, Text } from 'components/chroma';
import React, { FunctionComponent } from 'react';
import Media from 'react-media';
import { SCREEN } from 'scenes/common/types/screen';
import styled from 'styled-components';
import { Award } from './types';

interface LogoProps {
  inFooter?: boolean;
}
const Logo = styled.img`
  height: ${(props: LogoProps) => (props.inFooter ? '118px;' : '130px;')};
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  margin-left: 1.75rem;

  @media (min-width: ${SCREEN.LARGE}px) {
    margin-left: 1.25rem;
  }
`;

const AwardContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;

  p {
    line-height: 1.375rem !important;
  }
`;

const AwardContent = styled.div`
  padding-right: 1rem;
`;

const AwardCard: FunctionComponent<{
  award: Award;
  margin?: object;
  inFooter?: boolean;
}> = ({ award, margin, inFooter }) => {
  const { content, logo, disclaimerSymbol } = award;
  return (
    <Media query={{ maxWidth: SCREEN.LARGE - 1 }}>
      {(matches) => (
        <Card margin={{ ...margin, bottom: 1 }} justifyLeft={matches}>
          <AwardContainer>
            <Logo
              src={logo}
              tabIndex={-1}
              alt=""
              inFooter={inFooter ?? false}
            />
            <AwardContent>
              <Text margin={{ bottom: 0 }}>
                <strong>
                  {content}
                  {disclaimerSymbol && <sup>&nbsp;{disclaimerSymbol}</sup>}
                </strong>
              </Text>
            </AwardContent>
          </AwardContainer>
        </Card>
      )}
    </Media>
  );
};

export { AwardCard };
